// Unpublished Work © 2020-2024 Deere & Company.

import initUiCore from 'Src/init';

initUiCore();
